/**
 * AWS SDK Browser Polyfills
 * These are required to make AWS SDK work in the browser environment
 */
import { Buffer } from 'buffer';
import process from 'process';

// Set up global for AWS SDK
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).global = window;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).process = process;

  // Set Buffer for AWS SDK
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).Buffer = Buffer;
}

// Export an empty default to allow importing this file
export default {};
